import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Landing from "./screens/Landing.jsx";
import BlogPage from "./screens/BlogPage.jsx";
import CareerPage from "./screens/CareerPage.jsx";

export default function App() {
  const getRoute = () => {
    const hash = typeof window !== "undefined" ? window.location.hash : "";
    const path = hash ? hash.replace(/^#/, "") : "/";
    return path;
  };
  const [route, setRoute] = useState(getRoute());
  useEffect(() => {
    const onHashChange = () => setRoute(getRoute());
    window.addEventListener("hashchange", onHashChange);
    return () => {
      window.removeEventListener("hashchange", onHashChange);
    };
  }, []);
  const isBlog = route.startsWith("/blog/");
  const isCareer = route === "/career";
  const slug = isBlog ? route.split("/").pop() : null;
  return (
    <>
      <Helmet>
        <title>nFinity Solutions</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
      </Helmet>
      {isCareer ? <CareerPage /> : isBlog ? <BlogPage slug={slug} /> : <Landing />}
    </>
  );
}

